import {
  Modal,
  View,
  TouchableOpacity,
  TouchableWithoutFeedback,
  SafeAreaView,
} from "react-native";
import StyledText from "../../common/ui/styled-text";
import { X } from "lucide-react-native";

interface TicketDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const TicketDialog = ({ open, onOpenChange }: TicketDialogProps) => {
  const handleClose = () => {
    onOpenChange(false);
  };

  return (
    <Modal
      visible={open}
      transparent={true}
      animationType="fade"
      statusBarTranslucent
      onRequestClose={handleClose}
    >
      <TouchableWithoutFeedback onPress={handleClose}>
        <SafeAreaView className="flex-1 bg-black/50">
          <View className="flex-1 justify-center items-center px-4">
            <TouchableWithoutFeedback>
              <View className="bg-white w-full max-w-xl rounded-lg overflow-hidden">
                <View className="flex-row justify-between items-center p-4 border-b">
                  <StyledText className="text-lg font-bold">
                    Submit Support Ticket
                  </StyledText>
                  <TouchableOpacity onPress={handleClose} className="p-1">
                    <X size={20} color="#000" />
                  </TouchableOpacity>
                </View>
                <View className="w-full bg-white">
                  <iframe
                    title="Submit Support Ticket"
                    src={`https://plugins.crisp.chat/urn:crisp.im:contact-form:0/contact/${process.env.EXPO_PUBLIC_CRISP_WEBSITE_ID}`}
                    referrerPolicy="origin"
                    sandbox="allow-forms allow-popups allow-scripts allow-same-origin"
                    width="100%"
                    height="600px"
                    frameBorder="0"
                  ></iframe>
                </View>
              </View>
            </TouchableWithoutFeedback>
          </View>
        </SafeAreaView>
      </TouchableWithoutFeedback>
    </Modal>
  );
};

export default TicketDialog;
